var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 4 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M3.5 2a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "m.5 13.5 2.67-.717a.448.448 0 0 0 .33-.427V6.131c0-.433-.174-.847-.483-1.153A1.66 1.66 0 0 0 1.85 4.5H.877a.38.38 0 0 0-.348.23.37.37 0 0 0-.029.143V13.5Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -0.469,
    x2: 1.469,
    y1: 1.469,
    y2: 4.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDAC42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -0.469,
    x2: 4.729,
    y1: 7.407,
    y2: 10.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDAC42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F80"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.9ac8b406d1cbcabf1f56dfa97c11ff56.svg";
export { ForwardRef as ReactComponent };